// extracted by mini-css-extract-plugin
export var banner = "_3i-0";
export var icon = "_3i-1";
export var message = "_3i-2";